export default __webpack_public_path__ + "static/media/order_detail.3951b410.svg";